import type { CallbackInterface } from 'recoil'

import { logAppError } from 'Helpers/logger'

import type { PageStateType } from 'Types/state'

import { errorUpdater, loaderUpdater, pageState } from 'State/page'

import type { ModalDelStatsContactState } from 'Pages/RecipientsList/model'
import { modalDelStatsContactState } from 'Pages/RecipientsList/recoil/state/modals'

import {
  getUserEmail,
  sendContactRequest,
} from 'Pages/RecipientsList/recoil/services/engagement'
import { notifyDelStatsContactSendSuccess } from 'Pages/RecipientsList/recoil/services/notifications'

export const modalDelStatsContactOpenCallback =
  ({ set }: CallbackInterface) =>
  async ({
    requestTitle,
    requestDescription,
  }: Pick<
    ModalDelStatsContactState,
    'requestTitle' | 'requestDescription'
  >) => {
    const email = await getUserEmail()
    set(modalDelStatsContactState, (prev) => ({
      ...prev,
      email,
      show: true,
      requestTitle,
      requestDescription,
    }))
  }

export const modalDelStatsContactChangeCallback =
  ({ set }: CallbackInterface) =>
  async (email: string) => {
    set(modalDelStatsContactState, (prev) => ({
      ...prev,
      email,
      isDirty: true,
    }))
  }

export const modalDelStatsContactCancelCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalDelStatsContactState)
  }

export const modalDelStatsContactConfirmCallback =
  ({ set, snapshot, reset }: CallbackInterface) =>
  async () => {
    set(pageState, loaderUpdater(true))

    const { email, requestTitle, requestDescription } =
      await snapshot.getPromise(modalDelStatsContactState)

    try {
      await sendContactRequest(email, requestTitle, requestDescription)

      notifyDelStatsContactSendSuccess()
    } catch (error) {
      logAppError({
        Component: 'RecipientsList',
        Method: 'modalDelStatsContactConfirmCallback',
        appError: error,
      })

      set<PageStateType>(pageState, errorUpdater)
    }

    reset(modalDelStatsContactState)

    set(pageState, loaderUpdater(false))
  }
